import React, { useEffect, useState } from "react";
import { API_HOST } from "../../api_utils";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Box, Divider, Modal } from "@mui/material";
import Loader from "../../Shared_Components/Loader";
import { TbArrowBackUp } from "react-icons/tb";
import { RiSave2Fill } from "react-icons/ri";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

function LoanEditTransaction(props) {
  const { userDataFromStorage, colorTheme } = props;
  const { id } = useParams();

  const [transactionDetail, setTransactionDetail] = useState({});

  const [showEditPayment, setShowEditPayment] = useState(false);
  const [transactionEditDetail, setTransactionEditDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const [formattedTransactionDate, setFormattedTransactionDate] = useState("");

  const [transactionEditSuccess, setTransactionEditSuccess] = useState(false);
  const [transactionDeleteSuccess, setTransactionDeleteSuccess] =
    useState(false);
  const [transactionIdForDeletion, setTransactionIdForDeletion] = useState("");
  const [showDeleteTransactionModel, setShowDeleteTransactionModel] =
    useState(false);

  const getTransactionDetailHandler = async () => {
    let api = `${API_HOST}/api/loan_header/loan_transaction/${id}`;

    const config = {
      header: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    const { data } = await axios.get(api, config);

    if (!data.message) {
      console.log("data:::::::::::", data);

      const inputDate = new Date(data?.cash_disbursed_date);

      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      console.log("input date", inputDate);

      const day = inputDate.getDate();
      console.log("day::::", day);
      const month = months[inputDate.getMonth()];
      const year = inputDate.getFullYear();

      const formattedDate = `${day} ${month}, ${year}`;

      let newData = {
        ...data,
        cashDisbursedDate: formattedDate,
      };

      setTransactionDetail(newData);
    } else {
      setTransactionDetail({});
    }
  };

  useEffect(() => {
    getTransactionDetailHandler();

    return () => {
      setTransactionDeleteSuccess(false);
      setTransactionEditSuccess(false);
    };
  }, [transactionEditSuccess, transactionDeleteSuccess]);

  const editTransactionHander = async (reason) => {
    setLoading(true);
    console.log("reason", reason);
    if (reason === "edit") {
      setTransactionEditSuccess(false);
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };

      transactionEditDetail.reason = "edit";

      console.log("res 1", transactionEditDetail);
      const { data } = await axios.post(
        `${API_HOST}/api/transactions/edit_transaction_amount`,
        transactionEditDetail,
        config
      );

      if (data && data.message === "Transaction Edited Successfully!!!") {
        setLoading(false);
        setShowDeleteTransactionModel(false);
        setTransactionDeleteSuccess(true);
        toast.success("Payment Detail Deleted Successfully !!!");
      }
    } else {
      setTransactionEditSuccess(false);
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };

      transactionEditDetail.transaction_amount = 0;
      transactionEditDetail.reason = "deleted";

      console.log("res 2", transactionEditDetail);
      const { data } = await axios.post(
        `${API_HOST}/api/transactions/edit_transaction_amount`,
        transactionEditDetail,
        config
      );

      if (data && data.message === "Transaction Deleted Successfully!!!") {
        setLoading(false);
        setShowDeleteTransactionModel(false);
        setTransactionDeleteSuccess(true);
        toast.success("Payment Detail Deleted Successfully !!!");
      }
    }
  };

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden"
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden"
      }>
      <p className="text-gray-800 text-[1.8rem] tracking-wider">Loan Detail</p>
      <div className="flex flex-col space-y-4 mt-[2rem] ">
        <div className="flex justify-start items-center space-x-6 text-gray-600">
          <p className=" w-1/3">Customer Nickname</p>
          <p className="flex-1  flex justify-start space-x-3 items-center">
            {Array.isArray(transactionDetail.customer_nickname) &&
              transactionDetail.customer_nickname.map((nickname, index) => (
                <span key={index}>{nickname}</span>
              ))}
          </p>
        </div>
        <div className="flex justify-start items-center space-x-6 text-gray-600">
          <p className=" w-1/3">Agent Name</p>
          <p className="flex-1">
            {transactionDetail && transactionDetail.agent_name}
          </p>
        </div>
        <div className="flex justify-start items-center space-x-6 text-gray-600">
          <p className=" w-1/3">Loan Product</p>
          <p className="flex-1">
            {transactionDetail && transactionDetail.loan_product}
          </p>
        </div>
        <div className="flex justify-start items-center space-x-6 text-gray-600">
          <p className=" w-1/3">Customer Stamp Duty</p>
          <p className="flex-1">
            {transactionDetail && transactionDetail.customer_stamp_duty}
          </p>
        </div>
        <div className="flex justify-start items-center space-x-6 text-gray-600">
          <p className=" w-1/3">Cash Dispursed Date</p>
          <p className="flex-1">
            {transactionDetail && transactionDetail.cashDisbursedDate}
          </p>
        </div>
      </div>

      <div className="bg-white md:text-[0.75rem] lg:text-[1rem]">
        <p
          id="transaction"
          className="change-bg text-white px-[0.5rem] py-[1rem] mt-6">
          Payment Details
        </p>
        <div className="overflow-scroll px-[0.5rem]">
          <table className="md:w-[100%] xl:w-[100%] w-[300%] ">
            <thead className="h-[6vh]">
              <tr>
                <th className="text-start border-l border-t border-r border-gray-400 px-[0.2rem]">
                  Transaction Number
                </th>
                <th className="text-start border-r border-t border-gray-400 px-[0.2rem]">
                  Transaction Date
                </th>
                <th className="text-start border-r border-t border-gray-400 px-[0.2rem]">
                  Transaction Amount
                </th>
                <th className="text-start border-r border-t border-gray-400 px-[0.2rem]"></th>
                <th className="text-start border-r border-t border-gray-400 px-[0.2rem]"></th>
              </tr>
            </thead>
            <tbody>
              {transactionDetail &&
                transactionDetail.transactions &&
                transactionDetail.transactions.length &&
                transactionDetail.transactions.map((x, index) => {
                  const inputDate = new Date(x?.transaction_date);

                  const months = [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                  ];

                  console.log("input date", inputDate);

                  const day = inputDate.getDate();
                  console.log("day::::", day);
                  const month = months[inputDate.getMonth()];
                  const year = inputDate.getFullYear();

                  const formattedDate = `${day} ${month}, ${year}`;

                  return (
                    <tr key={index}>
                      <td
                        className={
                          index === transactionDetail?.transactions?.length - 1
                            ? "text-start border-l border-t border-r border-b border-gray-400 px-[0.2rem]"
                            : "text-start border-l border-t border-r border-gray-400 px-[0.2rem]"
                        }>
                        {x.transaction_number}
                      </td>
                      <td
                        className={
                          index === transactionDetail?.transactions?.length - 1
                            ? "text-start border-t border-r border-gray-400 px-[0.2rem] border-b"
                            : "text-start border-t border-r border-gray-400 px-[0.2rem]"
                        }>
                        {formattedDate}
                      </td>
                      <td
                        className={
                          index === transactionDetail?.transactions?.length - 1
                            ? "text-start border-t border-r border-gray-400 px-[0.2rem] border-b"
                            : "text-start border-t border-r border-gray-400 px-[0.2rem]"
                        }>
                        {"MYR "} {x.transaction_amount}
                      </td>

                      <td
                        className={
                          index === transactionDetail?.transactions?.length - 1
                            ? "text-center border-t border-r border-gray-400 px-[0.2rem] border-b py-[0.5rem]"
                            : "text-center border-t border-r border-gray-400 px-[0.2rem] py-[0.5rem]"
                        }>
                        <button
                          onClick={() => {
                            setTransactionEditDetail(x, "edit");
                            setShowEditPayment(true);
                            setFormattedTransactionDate(formattedDate);
                          }}
                          className="px-6 py-2 rounded-lg bg-green-500 hover:bg-green-100 text-white hover:text-green-500 transition duration-[0.3s]">
                          Edit Payment
                        </button>
                      </td>

                      <td
                        className={
                          index === transactionDetail?.transactions?.length - 1
                            ? "text-center border-t border-r border-gray-400 px-[0.2rem] border-b py-[0.5rem]"
                            : "text-center border-t border-r border-gray-400 px-[0.2rem] py-[0.5rem]"
                        }>
                        <button
                          onClick={() => {
                            setTransactionEditDetail(x, "delete");
                            setShowDeleteTransactionModel(true);
                          }}
                          className="px-6 py-2 rounded-lg bg-rose-500 hover:bg-rose-100 text-white hover:text-rose-500 transition duration-[0.3s]">
                          Delete Payment
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>

      <Modal
        open={showEditPayment}
        onClose={() => setShowEditPayment(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="md:w-[50%] w-[95%]  rounded-lg bg-white absolute top-[8%] mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">Edit Payment Detail</p>
              </div>
              <Divider />

              <div className="p-[0.5rem]">
                {/* Transaction date (Required) */}
                <div className="grid grid-cols-6 m-[0.3em]">
                  <label
                    htmlFor="date"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Transaction Number</span>
                  </label>
                  <input
                    value={transactionEditDetail.transaction_number}
                    type="text"
                    id="text"
                    className="p-[0.5rem] border border-gray-500 rounded-lg flex-1 outline-none col-span-4"
                    placeholder="Enter A Transaction Date"
                    disabled={true}
                  />
                </div>

                <div className="grid grid-cols-6 m-[0.3em]">
                  <label
                    htmlFor="date"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Transaction Date</span>
                  </label>
                  <input
                    value={formattedTransactionDate}
                    type="text"
                    id="text"
                    className="p-[0.5rem] border border-gray-500 rounded-lg flex-1 outline-none col-span-4"
                    placeholder="Enter A Transaction Date"
                    disabled={true}
                  />
                </div>

                <div className="grid grid-cols-6 m-[0.3em]">
                  <label
                    htmlFor="amt-outstanding"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Transaction Amount</span>
                    <span className="text-red-600 text-lg">*</span>
                  </label>
                  <input
                    value={transactionEditDetail.transaction_amount}
                    onChange={(e) =>
                      setTransactionEditDetail((prevState) => ({
                        ...prevState,
                        transaction_amount: e.target.value,
                      }))
                    }
                    type="number"
                    id="number"
                    className="p-[0.5rem] border border-gray-500 rounded-lg flex-1 outline-none col-span-4"
                    placeholder="Enter A Transaction Amount"
                  />
                </div>

                <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
                  <button
                    onClick={() => setShowEditPayment(false)}
                    className="flex justify-center items-center space-x-2 bg-purple-400 text-purple-50 px-[1rem] py-[0.5rem] rounded hover:text-purple-500 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    onClick={(e) => editTransactionHander("edit")}
                    className="flex justify-center items-center space-x-2 bg-green-400 text-green-50 px-[1rem] py-[0.5rem] rounded hover:text-green-500 hover:bg-green-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Save</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>

      <Modal
        open={showDeleteTransactionModel}
        onClose={() => setShowDeleteTransactionModel(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="md:w-[50%] w-[95%]  rounded-lg bg-white absolute top-[8%] mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">Delete Payment Detail</p>
              </div>
              <Divider />

              <div className="p-[0.5rem]">
                {/* Transaction date (Required) */}
                <p>Are You Sure You Want To Delete This Payment Record?</p>

                <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
                  <button
                    onClick={() => setShowDeleteTransactionModel(false)}
                    className="flex justify-center items-center space-x-2 bg-purple-400 text-purple-50 px-[1rem] py-[0.5rem] rounded hover:text-purple-500 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    onClick={(e) => editTransactionHander("delete")}
                    className="flex justify-center items-center space-x-2 bg-green-400 text-green-50 px-[1rem] py-[0.5rem] rounded hover:text-green-500 hover:bg-green-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Save</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default LoanEditTransaction;
